import React from 'react'
import MediaMenuItem from '../MediaMenu/MediaMenuItem'
import PlayInButtonProps from './types'
import { IconType } from '@bt-react/components/Icon'

const PlayInButton: React.FC<PlayInButtonProps> = props =>
  <MediaMenuItem
    onClick={props.mediaDrawerOpen ? props.closeMediaDrawer : props.openMediaDrawer}
    dataBdd={'talks-play-in-button'}
    active={props.isActive}
    icon={IconType.iconName.playOutline}
    text={`Play-in video`}
    disabled={props.disabled}
    notifications={props.videoListCount}
    mediaType='PLAY_IN'
  />

export default PlayInButton
